import posthog from "posthog-js";

// Shared identity state. Both experiment composables check this before
// evaluating flags so we never call getFeatureFlag() for an anonymous user.
let hasIdentified = false;

export const IS_PROD = import.meta.env.VITE_ENV === "Production";

/**
 * Identify the contact to PostHog. Idempotent — safe to call from multiple
 * places (App.vue on persisted session restore, MFA.vue on fresh login).
 * The first call wins; subsequent calls are no-ops.
 */
export function identifyUser(contact) {
  if (!contact?.record_id) return;
  if (hasIdentified) return;
  hasIdentified = true;
  try {
    posthog.identify(contact.record_id, {
      email: contact.email,
      name: `${contact.first_name ?? ""} ${contact.last_name ?? ""}`.trim(),
    });
  } catch {}
}

/** Reset PostHog identity on logout. Clears hasIdentified so the next login re-identifies. */
export function resetPostHog() {
  hasIdentified = false;
  try {
    posthog.reset();
  } catch {}
}

/** Read-only check used by experiment composables to gate flag evaluation. */
export function isIdentified() {
  return hasIdentified;
}

export function usePostHog() {
  posthog.init(
    `${import.meta.env.VITE_ENV === "QA" ? "phc_zoyKtvrbmBFZNdeqk3mrY3JArt9xVfwQYGTd5gmGzUC4" : "phc_qVFo44yg8KS6CPsdDUFSprrTkjcEAdcjKMmtwhEvf43C"}`,
    {
      api_host: "https://p.phoenixenergy.com",
      defaults: "2026-01-30",
      // Prevent PostHog from sending $feature_flag_called events automatically on
      // every page load for anonymous users. We evaluate flags explicitly in
      // initExperiment() only after posthog.identify() has been called.
      advanced_disable_feature_flags_on_first_load: true,
    }
  );

  return { posthog };
}

// Call this whenever the theme is known/changes
export function setPostHogTheme(theme) {
  posthog.setPersonProperties(theme); // updates the person profile
  posthog.register(theme); // attaches theme to every future event
}
